<template>
    <ui-input-base-textarea
        v-bind:is-invalid="isInvalid"
        v-bind="model"
        v-on:input="inputHandler"
    />
</template>

<script>
export default {
    name: 'ui-input-textarea',
    props: {
        model: {
            type: Object,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
        },
    },
    model: {
        prop: 'value',
        event: 'input',
    },
    methods: {
        inputHandler(newValue) {
            this.$emit('input', newValue);
        },
    },
};
</script>

<style scoped lang="less">
@import "~theme";

.ui-input-textarea {
    width: 100%;
}
</style>
